import axios from 'axios';
import getSession from '../getSessionId';

const ajax = (params: any) => {
    params.method = params.method || 'GET';
    params.method = params.method.toLocaleUpperCase();

    if (params.method == 'GET' && !params.params && params.data) {
        params.params = params.data;
        delete params.data;
    }

    // return (params.method == 'POST' ? axios.post(params.url, qs.stringify(params.data)) : axios(params))
    return axios(params)
        .then((res: any) => {
            if (res.data.code == '0') {
                return res.data.data;
            } else if (res.data.code == '309' || res.data.code == '401') {
                // 未登录,跳去登录
                localStorage.removeItem('token')
                location.reload()
                // return Promise.reject(res)
            } else if (res.data.toString().indexOf('timed out') >= 0) {
                console.warn('ajaxReject', res.data);
                return Promise.reject({
                    code: '9999',
                    msg: '服务器超时，请稍后再试',
                });

            } else {
                console.warn('ajaxReject', params, res.data);
                return Promise.reject(res.data);
            }

        }, (error: any) => {
            console.warn('ajaxError', params, error);
            if (error.response) {
                const ret = {
                    code: error.response.status,
                    msg: error.message,
                };

                return Promise.reject(ret);

            } else if (error.request) {
                const ret = {
                    code: '-1',
                    msg: '服务无响应',
                };
                return Promise.reject(ret);

            } else {
                const ret = {
                    code: '-2',
                    msg: error.message,
                };

                return Promise.reject(ret);

            }
        });
};
axios.interceptors.request.use((config) => {
    if (localStorage.getItem('token')) {
        config.headers['JD-DEPENDENT-TOKEN'] = localStorage.getItem('token')
    }
    return config
})

/**
 * 发起一个get请求
 * @param url 请求地址
 * @param data 数据
 * @example
 *  const data = await get('test', {});
 */
export function get(url: string, data: any = {}) {
    data.sessionId = getSession();
    return ajax({
        url,
        params: data,
    });
}

ajax.get = get;

export function post(url: string, data: any = {}) {
    data.sessionId = getSession();
    return ajax({
        url,
        method: 'post',
        data,
    });
}

ajax.post = post;

export default ajax;
